export const dobFormatter = (dateOfBirth) => {
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateOfBirth)) {
    return `${dateOfBirth.substring(5, 7)}/${dateOfBirth.substring(
      8
    )}/${dateOfBirth.substring(0, 4)}`;
  }
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateOfBirth)) {
    return `${dateOfBirth.substring(6)}-${dateOfBirth.substring(
      0,
      2
    )}-${dateOfBirth.substring(3, 5)}`;
  }

  return '';
};
